import type { DeepString } from "@/lib/i18n";

/**
 * CBlog - polskie tlumaczenia (Blog - lista + wpis).
 */
export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyList: "Brak wpisów do wyświetlenia.",
  readMore: "Czytaj więcej ->",
  backToList: "Wróć do listy",
  paginationAria: "Paginacja",
  /** `byAuthor("Jan Kowalski")` -> "Autor: Jan Kowalski". */
  byAuthor: (name: string): string => `Autor: ${name}`,
  /** `formatDate("2026-05-13")` -> "13 maja 2026". */
  formatDate: (iso: string): string => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    const months = [
      "stycznia", "lutego", "marca", "kwietnia", "maja", "czerwca",
      "lipca", "sierpnia", "września", "października", "listopada", "grudnia",
    ];
    const month = parseInt(m[2], 10) - 1;
    if (month < 0 || month > 11) return iso;
    return `${parseInt(m[3], 10)} ${months[month]} ${m[1]}`;
  },
  /** `paginationLabel(2, 7)` -> "Strona 2 z 7". */
  paginationLabel: (page: number, totalPages: number) =>
    `Strona ${page} z ${totalPages}`,
  paginationHint: "Paginacja zostanie podłączona w kolejnej iteracji",
  /** `readingMinutes(6)` -> "6 min". Krotki suffix pod tytulem artykulu. */
  readingMinutes: (n: number): string => `${n} min`,
} as const;

export type CBlogTranslations = DeepString<typeof pl>;
